import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  LayoutDashboard,
  Hammer,
  FolderOpen,
  Settings,
  MoreHorizontal,
  X,
  Megaphone,
  CreditCard,
  Brain,
  Bell,
  HelpCircle,
  Coins,
  ScrollText,
  Shield,
  Cpu,
  Users,
} from 'lucide-react'
import { cn } from '@/lib/utils'

const primaryItems = [
  { icon: Hammer, label: 'Build', path: '/build' },
  { icon: LayoutDashboard, label: 'Dashboard', path: '/dashboard' },
  { icon: FolderOpen, label: 'Projects', path: '/projects' },
  { icon: Settings, label: 'Settings', path: '/settings' },
]

const moreItems = [
  { icon: Megaphone, label: 'Marketing', path: '/marketing' },
  { icon: Coins, label: 'Token Usage', path: '/token-usage' },
  { icon: ScrollText, label: 'Audit Log', path: '/audit-log' },
  { icon: Brain, label: 'Knowledge', path: '/knowledge' },
  { icon: Shield, label: 'Rules', path: '/rules' },
  { icon: Cpu, label: 'Models', path: '/model-settings' },
  { icon: Users, label: 'Team', path: '/team' },
  { icon: CreditCard, label: 'Billing', path: '/billing' },
  { icon: Bell, label: 'Notifications', path: '/notifications' },
  { icon: HelpCircle, label: 'Help', path: '/help' },
]

export function MobileNav() {
  const location = useLocation()
  const [showMore, setShowMore] = useState(false)

  return (
    <>
      {/* Overflow menu */}
      {showMore && (
        <div className="fixed inset-0 z-60 lg:hidden">
          <div
            className="absolute inset-0 bg-black/60 backdrop-blur-xs"
            onClick={() => setShowMore(false)}
          />
          <div className="absolute bottom-16 left-2 right-2 bg-[#0a0a0a] border border-white/10 rounded-xl p-4 max-h-[60vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-3">
              <span className="text-sm font-medium text-gray-300">More</span>
              <button
                onClick={() => setShowMore(false)}
                className="p-1 rounded-md hover:bg-white/10"
              >
                <X className="w-4 h-4 text-gray-400" />
              </button>
            </div>
            <div className="grid grid-cols-3 gap-2">
              {moreItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setShowMore(false)}
                  className={cn(
                    'flex flex-col items-center gap-1 p-3 rounded-lg text-xs transition-colors',
                    location.pathname === item.path
                      ? 'bg-lime/10 text-lime'
                      : 'text-gray-400 hover:bg-white/5'
                  )}
                >
                  <item.icon className="w-5 h-5" />
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Bottom bar */}
      <nav className="fixed bottom-0 left-0 right-0 z-50 bg-[#0a0a0a]/90 backdrop-blur-xl border-t border-white/10 lg:hidden">
        <div className="flex items-center justify-around h-14">
          {primaryItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                'flex flex-col items-center gap-0.5 text-xs transition-colors',
                location.pathname.startsWith(item.path) ? 'text-lime' : 'text-gray-400'
              )}
            >
              <item.icon className="w-5 h-5" />
              {item.label}
            </Link>
          ))}
          <button
            onClick={() => setShowMore((v) => !v)}
            className={cn(
              'flex flex-col items-center gap-0.5 text-xs transition-colors',
              showMore ? 'text-lime' : 'text-gray-400'
            )}
          >
            <MoreHorizontal className="w-5 h-5" />
            More
          </button>
        </div>
      </nav>
    </>
  )
}
